var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4159_3804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 2.40005C19.6319 2.40005 23.0479 3.81605 25.6159 6.38405C28.1839 8.95205 29.5999 12.368 29.5999 16C29.5999 19.632 28.1839 23.048 25.6159 25.616C23.0479 28.184 19.6319 29.6 15.9999 29.6C12.3679 29.6 8.9519 28.184 6.3839 25.616C1.0799 20.312 1.0799 11.688 6.3839 6.38405C8.9519 3.81605 12.3679 2.40005 15.9999 2.40005ZM15.9999 0.800049C12.1119 0.800049 8.2159 2.28005 5.2479 5.24805C-0.688102 11.184 -0.688102 20.8081 5.2479 26.744C8.2159 29.72 12.1119 31.2 15.9999 31.2C19.8879 31.2 23.7839 29.72 26.7439 26.752C32.6799 20.816 32.6799 11.192 26.7439 5.25605C23.7839 2.28005 19.8879 0.800049 15.9999 0.800049Z",
    fill: "#353EBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 25.5999C15.56 25.5999 15.2 25.2399 15.2 24.7999V7.1999C15.2 6.7599 15.56 6.3999 16 6.3999C16.44 6.3999 16.8 6.7599 16.8 7.1999V24.7999C16.8 25.2399 16.44 25.5999 16 25.5999Z",
    fill: "#353EBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7999 16.8H7.1999C6.7599 16.8 6.3999 16.44 6.3999 16C6.3999 15.56 6.7599 15.2 7.1999 15.2H24.7999C25.2399 15.2 25.5999 15.56 25.5999 16C25.5999 16.44 25.2399 16.8 24.7999 16.8Z",
    fill: "#353EBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4159_3804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircle);
export default __webpack_public_path__ + "static/media/plus-circle.62873fc790a69c0a25ec903e39b0e96b.svg";
export { ForwardRef as ReactComponent };